import React from 'react'

/* Atoms */
import Box from 'components_new/atoms/Box'
import Text from 'components_new/atoms/Text'

/* Molecules */
import SimpleDialog from 'components_new/molecules/SimpleDialog'

interface TestEnvironmentInfoDialogProps {
  open: boolean
  onClose: () => void
}

const Section = ({
  title,
  children
}: {
  title: string
  children: React.ReactNode
}) => (
  <Box sx={{ mb: 2.5 }}>
    <Text variant="body1" fontWeight="bold" sx={{ mb: 0.5 }}>
      {title}
    </Text>
    <Text variant="body2" color="text.secondary" component="div">
      {children}
    </Text>
  </Box>
)

const TestEnvironmentInfoDialog = (props: TestEnvironmentInfoDialogProps) => {
  const { open, onClose } = props

  return (
    <SimpleDialog
      title="Så fungerar testmiljön"
      helperText="En översikt över vad som händer när testmiljön aktiveras för en kund."
      open={open}
      onClose={onClose}
      hasClose
      fullWidth
      maxWidth="sm"
    >
      <Section title="Vad är testmiljön?">
        Testmiljön är en parallell kopia av kundens modellering som vi på
        Homepal kan jobba i utan att kunden ser eller påverkas. Den är tänkt för
        att kunna prova ändringar i lugn och ro innan något rullas ut till
        produktion.
      </Section>

      <Section title="När är det tänkt att användas?">
        Främst när vi byter ett källsystem hos kunden och behöver kontrollera
        att modelleringen fungerar mot det nya systemet, men också för att testa
        större förändringar i modelleringen innan de läggs live.
      </Section>

      <Section title="Vad händer när jag aktiverar testmiljön?">
        En kopia av kundens nuvarande modellering skapas som en separat miljö.
        Kunden ser ingen skillnad — endast Homepal-användare har tillgång till
        testmiljön.
      </Section>

      <Section title="Hur växlar jag mellan test och produktion?">
        I dina personliga inställningar finns en toggle som heter “Använd
        testmiljö”. När den är på visar portalen testmiljöns data och
        modellering. När den är av jobbar du som vanligt i produktion.
      </Section>

      <Section title="Vad händer när jag stänger av testmiljön?">
        Testmiljön och allt som modellerats där tas bort. Produktionen påverkas
        inte.
      </Section>
    </SimpleDialog>
  )
}

export default TestEnvironmentInfoDialog
